import { createSectionName } from 'components/Dashboard/helpers/controlActiveFilters';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import React, { useState } from 'react';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import CustomScrollbar from './CustomScrollbar';

const ScrollbarList = React.forwardRef((props, ref) => {
  const { contentResults } = useContentResults();
  const [isLoadingScroll, setIsLoadingScroll] = useState(false);

  const { children, createResults, additionalClass = '' } = props;
  const [heightContainer, containerRef] = useHeightContainer();

  const handleScroll = (scrollValues) => {
    const { scrollTop, scrollHeight, clientHeight } = scrollValues;
    //AE: Math.ceil sometimes can return a lower value than scrollHeight, in the cases where infinite scroll doesn't work that difference is 1, so we added a threshold to prevent it.
    const threshold = 1;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - threshold;
    if (scrolledToBottom) {
      load_more_results();
    }
  };

  const load_more_results = async () => {
    const sectionName = createSectionName();
    const section = contentResults[sectionName];

    if (section && createResults && sectionName !== 'ParliamentLive') {
      //AE: As we don't have now the unred filter, I'll not include on the create results function. If it's necessary see the hooks for each contentType
      let { thereIsMoreContent, pageNumber } = section;
      if (thereIsMoreContent && !isLoadingScroll) {
        setIsLoadingScroll(true);
        let newPage = pageNumber + 1;
        let parameter = newPage;
        await createResults({ pageNumber: parameter });
        setIsLoadingScroll(false);
      }
    }
  };

  return (
    <div ref={containerRef}>
      <CustomScrollbar
        className={`main-content-scrollbar ${additionalClass}`}
        style={{ height: `${heightContainer}px` }}
        maximalThumbYSize={100}
        ref={ref}
        onScroll={(scrollValues) => {
          handleScroll(scrollValues);
        }}
      >
        {children}
      </CustomScrollbar>
    </div>
  );
});

export default ScrollbarList;
